import { render } from "./Entrepreneurs.vue?vue&type=template&id=50a47996&scoped=true"
import script from "./Entrepreneurs.vue?vue&type=script&lang=js"
export * from "./Entrepreneurs.vue?vue&type=script&lang=js"

import "./Entrepreneurs.vue?vue&type=style&index=0&id=50a47996&scoped=true&lang=scss"

import exportComponent from "/home/forge/olyo.io/app-src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50a47996"]])

export default __exports__